// Provides integration to PaintCare AWS Resources.

// eslint-disable-next-line max-classes-per-file
export const MOCK_PAINT_BASE_URL = 'https://paintcare.dbservices.com';
export const MOCK_PAINT_NAMESPACE = 'fmi/data/v1/databases/Site%20Locator';

export const AWS_DATA_API_BASE_URL = 'https://61oilk42ji.execute-api.us-east-1.amazonaws.com'; // PaintCare AWS API Gateway
export const AWS_DATA_API_NAMESPACE  = 'prod';  //PaintCare AWS prod stage

export const AWS_METRIC_API_BASE_URL = 'https://uzepgr4dhl.execute-api.us-east-1.amazonaws.com'; // PaintCare AWS prod stage
export const AWS_METRIC_API_NAMESPACE = 'prod'; // PaintCare AWS prod stage 
export class AWS_API {
  constructor() {
    this.baseUrl = AWS_DATA_API_BASE_URL;
    this.namespace = AWS_DATA_API_NAMESPACE ;
  }

  // eslint-disable-next-line class-methods-use-this
  errorHandler(error) {
    // send to sentry
    // send to UI that we have an error
    return error;
  }

  async makeRequest(url, opt) {
    /** Generic HTTP Helper Method */

    const options = {
      'Content-Type': 'application/json',
      'Referrer-Policy': 'no-referrer-when-downgrade',
      ...opt,
    };

    try {
      const response = await fetch(url, options);
      if (response.status < 300) {
        return response.json();
      }
      return this.errorHandler('not a 200');
    } catch (error) {
      return this.errorHandler(error);
    }
  }

  async getSitesByState(stateAbbr) {
    /** Returns sites by State Abbreviation (e.g. 'VA', 'CA') */

    const options = {
      method: 'GET',
    };
    const url = `${this.baseUrl}/${this.namespace}?state=${stateAbbr}`;

    const { response } = await this.makeRequest(url, options);
    const { data } = response || [];
    return data;
  }
}

export class MetricAPI {
  constructor() {
    this.baseUrl = AWS_METRIC_API_BASE_URL;
    this.namespace = AWS_METRIC_API_NAMESPACE;
    this.metricApiGatewayUrl = `${this.baseUrl}/${this.namespace}/events`; //should map to PaintCare AWS Service
  }
  // eslint-disable-next-line class-methods-use-this
  errorHandler(error) {
    // send to sentry
    // send to UI that we have an error
    return error;
  }

  async makeRequest(opt) {
    /** Generic HTTP Helper Method */

    try {
      const options = {
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': process.env.VUE_APP_AWS_METRIC_KEY,
        },
        mode: 'cors',
        ...opt,
      };
  
      const url = this.metricApiGatewayUrl; 
      const response = await fetch(url, options);
      if (response.status < 300) {
        return response.json();
      }
      return this.errorHandler('not a 200');
    } catch (error) {
      return this.errorHandler(error);
    }
  }
}